import React, { useEffect, useState } from "react";
import { Image, Upload, Space, message, Spin, Modal } from "antd";
import { apiCall } from "../../utils/Api";
import { UploadOutlined, PlusOutlined } from '@ant-design/icons';
import { isASAN } from "../../utils/Utils";
export default function InteriorImages(props) {

    const { isbn, eisbn, editing = false, cover_path = "/no-cover.png" } = props;
    const [uploading, setUploading] = useState(false);


    const uploadFile = (_file, _interior, _new = false) => {
        let _obj = { file: _file.file, isbn: isbn, interior_num: _interior };
        setUploading(true);
        apiCall("title/uploadInteriorImage", _obj, (_status, _result) => {
            if (_status) {

                Modal.success({
                    title: "Success",
                    content: <>Cover image update requested. The update may take a few minutes and requires a refresh.</>
                })

                if (_new) {
                    let _int = getPlaceholders(interiors);
                    _int.push({});
                    setInteriors(_int);
                }

            } else {
                message.error(_result.error)
            }
            setUploading(false);
        });
    }

    const getNextKey = (items) => {
        const existingKeys = items.map(item => item.key).filter(k => typeof k === 'number');
        if (existingKeys.length === 0) return 10000;
        return Math.max(...existingKeys) + 1;
    }

    function getPlaceholders(items) {
        const existingItems = items.filter(item => typeof item.key === 'number');
        if (existingItems.length === 0) return [];

        const keyMap = new Map(existingItems.map(item => [item.key, item]));
        const keys = [...keyMap.keys()];
        const minKey = Math.min(...keys);
        const maxKey = Math.max(...keys);

        const fullList = [];

        for (let i = minKey; i <= maxKey; i++) {
            if (keyMap.has(i)) {
                fullList.push(keyMap.get(i));
            } else {
                fullList.push({ key: i, placeholder: true });
            }
        }

        return fullList;
    }


    const [interiors, setInteriors] = useState(getPlaceholders(props.interiors));

    useEffect(() => {
        setInteriors(getPlaceholders(props.interiors));
    }, [props.interiors])



    const drawEdit = (_new = false, _key) => {
        if (uploading) {
            return (<Spin />)
        }

        return (
            <>
                <Space direction="vertical" size={15}>
                    <Upload customRequest={(e) => uploadFile(e, _key, _new)} accept=".jpg, .jpeg, .png"  >
                        <span style={{ "color": "#fff" }}><UploadOutlined /> <small>Upload</small></span>
                    </Upload>
                </Space>
            </>
        )
    }

    const drawItem = (_item, _index, _new = false) => {
        const {
            b2b = "",
            cb = "",
            key = "",
            placeholder = false,
        } = _item;

        let _img = (_new || placeholder) ? "https://bookmanager.com/i/nocover.png" : 'https://cdn1.bookmanager.com/i/m?b=' + eisbn + '&imgp=' + (key) + "&cb=" + cb;

        return (
            <div key={_index} className="bc" style={{ "maxHeight": "98px", "border": "1px solid", "padding": "3px", "width": "fit-content" }}>
                {(_new && (
                    <Upload customRequest={(e) => uploadFile(e, getNextKey(interiors), _new)} accept=".jpg, .jpeg, .png"  >
                        <PlusOutlined style={{ "fontSize": "25px", "padding": "32px", "cursor": "pointer" }} />
                    </Upload>
                ))}
                {(!_new && <Image style={{ objectFit: 'contain', "backgroundColor": "#00000011" }} height={90} width={90} preview={{ visible: false, mask: (editing) ? drawEdit(false, key) : false }} onError={(e) => e.target.src = cover_path} placeholder={""} src={_img} />)}
            </div>
        )
    }

    const showList = () => {

        return interiors.map((item, index) => {
            return (drawItem(item, index))
        })
    }

    if (!isASAN(isbn, true)) {
        return (<><div className="shim" /><div className="shim" /><div className="shim" /><div className="shim" /></>)
    }

    return (
        <div>
            <div>Interiors:</div>
            <div className="shim" />
            <Space wrap>
                {showList()}
                {drawItem({}, interiors.length, true)}
            </Space>
            <div className="shim" />
        </div>
    )

}